import { Text, Box, Loader } from '@ui-lib';
import * as styles from './Menu.css';
import { forwardRef, PropsWithChildren } from 'react';

type MenuItemCommonProps = {
  selected?: boolean;
  label: string;
  /** Use this to render an icon inside the tab adjacent to the tab label */
  icon?: React.ReactElement;
  /** Used this to position the icon before or after tab label */
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
  loading?: boolean;
};

type MenuItemButtonProps = MenuItemCommonProps & {
  onClick: () => void;
  href?: never;
  newTab?: never;
};

type MenuItemLinkProps = MenuItemCommonProps & {
  href: string;
  target?: string;
  newTab?: boolean;
  onClick?: never;
};

export const MenuItem = forwardRef<
  HTMLDivElement,
  PropsWithChildren<MenuItemLinkProps | MenuItemButtonProps>
>(({ children, selected = false, label, iconPosition = 'left', icon, disabled, loading, ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      component={rest.onClick || disabled ? 'button' : 'a'}
      onClick={!disabled ? rest.onClick : undefined}
      href={rest.href}
      target={rest.newTab ? '_blank' : undefined}
      rel={rest.newTab ? 'noopener noreferrer' : undefined}
      disabled={disabled}
      className={styles.menuItem({
        iconPosition,
        selected,
      })}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {icon}
          <Text
            className={styles.menuLabel({
              disabled,
            })}
            size="small"
            weight="demibold"
          >
            {label}
          </Text>
        </>
      )}
    </Box>
  );
});

MenuItem.displayName = 'MenuItem';
